/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import React, { Fragment as _, FC } from 'react';

interface ISubmitContinue {
  selected: string[];
  location: string;
  navigateToResults: boolean;
  onSubmit: () => void;
  children;
}

const SubmitContinue = (props: ISubmitContinue) => {
  const { selected, location, navigateToResults, onSubmit, children } = props;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '20px 0',
        //

        transition: 'opacity 0.2s',
        visibility:
          window.dev && window.dev()
            ? 'visible'
            : !selected.length
            ? 'hidden'
            : 'visible',
      }}
    >
      <div
        style={{
          cursor: 'pointer',
        }}
        onClick={() => {
          if (window.dev && window.dev()) {
            return;
          }

          navigateToResults ? requestAnimationFrame(onSubmit) : onSubmit();
        }}
      >
        <div
          css={css({
            'div [class*="NavigationButton"]': {
              top: '-10px',
              height: 'calc(100% + 20px)',
            },
          })}
        >
          {React.cloneElement(children, {
            location: navigateToResults ? location : 'next',
          })}
        </div>
      </div>
    </div>
  );
};

export default SubmitContinue;
